import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TlkModalWindowRef, TLK_MODAL_WINDOW_DATA, TlkModalWindowModule } from '@itero/ui-toolkit-angular/modal-window';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { CloseEmptyIconComponent } from '@itero/ui-toolkit-angular/icons';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AwarenessQrCodeComponent } from '@modules/awareness/components/awareness-qr-code/awareness-qr-code.component';

export interface AwarenessMiniPopupData {
	shouldNotifyCompanyByEmail$: Observable<boolean>;
	showLearningCenterPart$: Observable<boolean>;
	linkToTheLearningCenter$: Observable<string>;
}

@Component({
	selector: 'rx-awareness-mini-popup',
	templateUrl: './awareness-mini-popup.component.html',
	styleUrls: ['./awareness-mini-popup.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		TlkModalWindowModule,
		TlkButtonComponent,
		CloseEmptyIconComponent,
		AwarenessQrCodeComponent
	]
})
export class AwarenessMiniPopupComponent {
	constructor(
		public modalWindowRef: TlkModalWindowRef,
		@Inject(TLK_MODAL_WINDOW_DATA) public data: AwarenessMiniPopupData
	) {}
}
